import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Target, Shield, Clock, BarChart3, BrainCircuit } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: Target,
    title: 'Reduce la sobreoperación',
    desc: 'Establece límites simples que protegen tu capital.'
  }, {
    icon: Shield,
    title: 'Evita entradas por FOMO',
    desc: 'Aprende a esperar tu configuración ideal sin ansiedad.'
  }, {
    icon: BrainCircuit,
    title: 'Corta el Revenge Trading',
    desc: 'Protocolo claro para detenerte después de una pérdida.'
  }, {
    icon: Clock,
    title: 'Opera con estructura',
    desc: 'Horario definido, máximo de operaciones y stop diario.'
  }, {
    icon: BarChart3,
    title: 'Mide tu disciplina',
    desc: 'Ejecución medible para mejorar semana a semana.'
  }];
  return <Section background="darker" data-id="element-17">
      <div className="text-center mb-16" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-19">
          Lo que vas a lograr
        </h2>
        <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-20">
          Resultados concretos en tu operativa diaria desde la primera semana.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-21">
        {benefits.map((benefit, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-slate-900 p-6 rounded-xl border border-slate-800 hover:border-blue-500/30 transition-all hover:bg-slate-800/50" data-id="element-22">
            <div className="w-12 h-12 bg-blue-500/10 rounded-lg flex items-center justify-center mb-4 text-blue-500" data-id="element-23">
              <benefit.icon className="h-6 w-6" data-id="element-24" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-25">
              {benefit.title}
            </h3>
            <p className="text-slate-400" data-id="element-26">{benefit.desc}</p>
          </motion.div>)}
      </div>
    </Section>;
}